import { INamespaceActionCreator, IReducer } from '@omaze/redux';
import { AnyAction } from 'redux';

import { MODAL_ACTION } from '../../Modal.actions';
import { createModalActionCreatorFactory, createModalReducerFactory } from '../../Modal.factories';
import { IModalState } from '../../Modal.state';

export const createHideModalAction: INamespaceActionCreator = createModalActionCreatorFactory(
    MODAL_ACTION.HIDE,
    (): IModalState => {
        return {
            modalComponent: null,
            onOpenFunction: null,
            onCloseFunction: null,
            hideMask: false,
        };
    },
);

export const createHideModalReducer: IReducer<IModalState> = createModalReducerFactory(
    MODAL_ACTION.HIDE,
    (state: IModalState, action: AnyAction): void => {
        state.modalComponent = action.payload.modalComponent;
        state.onOpenFunction = action.payload.onOpenFunction;
        state.onCloseFunction = action.payload.onCloseFunction;
        state.hideMask = action.payload.hideMask;
    },
);
